// Shared formatting helpers.
export const inr = (n) => '₹' + Number(n || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const num = (n, d = 3) => Number(n || 0).toLocaleString('en-IN', { maximumFractionDigits: d });
export const dt = (s) => (s ? new Date(s).toLocaleString('en-IN', { dateStyle: 'medium', timeStyle: 'short' }) : '—');
export const day = (s) => (s ? new Date(s).toLocaleDateString('en-IN', { dateStyle: 'medium' }) : '—');
export const apiError = (e, fallback = 'Something went wrong') => e?.response?.data?.message || e?.message || fallback;

// Turn a shelf-life string ("6 months", "1 year", "30 days") into a yyyy-mm-dd
// date from today, so staff don't have to compute expiry. '' if unparseable.
export const shelfLifeToDate = (shelfLife) => {
  const m = String(shelfLife || '').match(/(\d+)\s*(day|week|month|year)/i);
  if (!m) return '';
  const n = Number(m[1]); const unit = m[2].toLowerCase();
  const d = new Date();
  if (unit === 'day') d.setDate(d.getDate() + n);
  else if (unit === 'week') d.setDate(d.getDate() + n * 7);
  else if (unit === 'month') d.setMonth(d.getMonth() + n);
  else if (unit === 'year') d.setFullYear(d.getFullYear() + n);
  return d.toISOString().slice(0, 10);
};

// Download an array of row-objects as a CSV file. `columns` = [{ key, label }].
export const downloadCSV = (filename, columns, rows) => {
  const esc = (v) => {
    const s = v == null ? '' : String(v);
    return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const head = columns.map((c) => esc(c.label)).join(',');
  const body = rows.map((r) => columns.map((c) => esc(r[c.key])).join(',')).join('\n');
  const blob = new Blob([head + '\n' + body], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = filename; a.click();
  URL.revokeObjectURL(url);
};

// Category → brand accent colour (mirrors avakaayafoods.com's category palette).
export const catColor = (category = '') => {
  const c = String(category).toUpperCase();
  if (c.includes('PICKLE')) return '#3d8b22';                                  // brand green
  if (c.includes('SWEET')) return '#b5365a';                                   // mithai rose
  if (/(SNACK|NAMKEEN|PAPAD|FRYUM)/.test(c)) return '#d4581a';                 // terracotta
  if (/(POWDER|MASALA)/.test(c)) return '#c47d0e';                             // turmeric
  if (/(DRY FRUIT|GHEE)/.test(c)) return '#b8860b';                            // deep gold
  return '#6b6b50';                                                            // neutral
};
